export const blocklist = [
  'thanksgiving',
  'halloween',
  'halloween_kids',
  'new_years',
  'dinner_party',
  'game_night',
  'save_the_date',
  'housewarming',
  'book_club',
  'potluck',
  'soccer',
  'valentines_day',
  'birthday_forteens',
  'holidayforkids',
  'hanukkah',
  'pet_party',
  'basketball',
  'guys_night',
  'back_to_school',
  'viewing_party',
  'sports_leagues',
  'brunch_lunch',
  'kids_activities',
  'girls_night',
];
